export default "__VITE_ASSET__QraKdjNt__"